module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_04-5a6a46bdb0d114f23efada3fa9ca77b9.jpg";